/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RequestedTeamMemberMatching } from './requested-team-member-matching';
import { Country } from './country';

export interface RequestedTeamMember {
  state?: RequestedTeamMemberStateEnum;
  remainingPositionsCount?: number;
  matchings?: Array<RequestedTeamMemberMatching> | null;
  countries?: Array<Country> | null;
  primaryCountry?: Country;
  referenceNumber?: number | null;
  title?: string | null;
  isDraft?: boolean;
  id: string;
  country?: string | null;
  countryCostType?: RequestedTeamMemberCountryCostTypeEnum | null;
  region?: string | null;
  orgCode?: string | null;
  businessArea?: string | null;
}
export enum RequestedTeamMemberStateEnum {
  Open = 'Open',
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
export enum RequestedTeamMemberCountryCostTypeEnum {
  BestCost = 'BestCost',
  HighCost = 'HighCost'
}
